import { createContext } from "react";
import { ProductContextProps } from "../interfaces";

export const productContext = createContext({} as ProductContextProps)